import React from 'react';
import { Rocket, Shield, Heart, CheckCircle } from '@phosphor-icons/react';

const whyStats = [
  { number: '5+', label: 'Years Experience', icon: Rocket, iconWrap: 'bg-blue-50/80 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400', delay: '0s' },
  { number: '500+', label: 'Client Satisfaction', icon: Heart, iconWrap: 'bg-pink-50/80 dark:bg-pink-500/20 text-pink-600 dark:text-pink-400', delay: '0.35s' },
  { number: '24/7', label: 'Technical Support', icon: Shield, iconWrap: 'bg-purple-50/80 dark:bg-purple-500/20 text-purple-600 dark:text-purple-400', delay: '0.7s' },
  { number: 'Fast', label: 'Secure & Scalable', icon: CheckCircle, iconWrap: 'bg-green-50/80 dark:bg-green-500/20 text-green-600 dark:text-green-400', delay: '1.05s' }
];

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="relative pt-10 md:pt-14 pb-8 md:pb-10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-sky-50 via-white to-indigo-50 dark:from-dark-900 dark:via-dark-900 dark:to-slate-900" />
      <div className="absolute -top-16 left-10 w-48 h-48 bg-brand-400/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-10 w-56 h-56 bg-purple-400/15 rounded-full blur-3xl" />

      <div className="section-max-width px-4 md:px-6 relative">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-display text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white">
            Why <span className="text-gradient">Choose Us</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {whyStats.map((stat) => {
            const Icon = stat.icon;
            return (
              <div
                key={stat.label}
                className="stat-glass rounded-2xl px-4 py-7 flex flex-col items-center text-center gap-2 hover:scale-[1.03] smooth-transition"
                style={{ animationDelay: stat.delay }}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl ${stat.iconWrap}`}>
                  <Icon weight="duotone" />
                </div>
                <span className="text-3xl font-extrabold font-display text-gray-900 dark:text-white tracking-tight">{stat.number}</span>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-300 leading-snug">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
